import { useState, useEffect } from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Drawer from './Drawer';

const getImpersonating = () => {
  try { return JSON.parse(localStorage.getItem('impersonating')); } catch { return null; }
};

const AppNavbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const impersonating = getImpersonating();

  useEffect(() => {
    document.body.style.paddingTop = impersonating ? '106px' : '';
    return () => { document.body.style.paddingTop = ''; };
  }, [impersonating]);

  if (location.pathname.startsWith('/admin') && !impersonating) return null;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleBackToAdmin = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('impersonating');
    window.location.href = '/admin/dashboard';
  };

  return (
    <>
      {impersonating && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000,
          background: 'linear-gradient(90deg, #b45309, #d97706)',
          color: '#fff', fontSize: 13, fontWeight: 600,
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
          padding: '8px 16px',
        }}>
          <span>⚠ Admin Mode — Viewing as {impersonating.name} ({impersonating.userCode})</span>
          <button onClick={handleBackToAdmin} style={{
            background: 'rgba(0,0,0,0.25)', border: '1px solid rgba(255,255,255,0.4)',
            color: '#fff', borderRadius: 6, padding: '3px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
          }}>
            ← Back to Admin
          </button>
        </div>
      )}
      <Navbar className="app-navbar" fixed="top" style={impersonating ? { top: 40 } : {}}>
        <Container>
          <div className="d-flex align-items-center gap-3">
            {user && (
              <button
                className="hamburger-btn"
                onClick={() => setDrawerOpen(true)}
                aria-label="Open menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            )}
            <Navbar.Brand as={Link} to="/">
              One<span className="accent">Circle</span>
            </Navbar.Brand>
          </div>

          <div className="ms-auto d-flex align-items-center gap-2">
            {user ? (
              <button className="btn-nav-logout" onClick={handleLogout}>
                Logout
              </button>
            ) : (
              <div className="d-flex align-items-center gap-3">
                <Link to="/login" className="nav-link-text">Login</Link>
                <Link to="/register" className="btn-nav-register">Register</Link>
              </div>
            )}
          </div>
        </Container>
      </Navbar>

      {user && (
        <Drawer show={drawerOpen} onHide={() => setDrawerOpen(false)} />
      )}
    </>
  );
};

export default AppNavbar;
